const lightTheme = {
    palette: {
        common: { black: '#000', white: '#FFF' },
        // Ajuste: El negro ahora es un "Off-Black" profundo (#0F172A)
        // Esto reduce el contraste agresivo con el blanco puro y se ve más "High-End"
        primary: {
            light: '#334155',
            main: '#0F172A', 
            dark: '#020617',
            contrastText: '#FFF',
            contrastAux: '#5A5A5A'
        },
        secondary: {
            light: '#e2e8f0',
            main: '#94a3b8',
            dark: '#475569',
            contrastText: '#FFF',
        },
        // Ajuste: El azul es más luminoso para que resalte sobre el negro sin perder seriedad
        link: {
            light: '#38bdf8', 
            lightTransparent: '#f0f9ff',
            main: '#0284c7', 
            dark: '#0369a1',
            contrastText: '#FFF',
            contrastAux: '#595959'
        },
        error: {
            light: '#f87171',
            main: '#dc2626',
            dark: '#991b1b',
            contrastText: '#FFF',
        },
        success: {
            lightTransparency: '#f0fff0',
            light: '#4ade80',
            main: '#16a34a',
            dark: '#14532d',
            contrastText: '#FFF'
        },
        primaryAux: {
            light: '#FFF',
            main: '#FFF',
            dark: '#FFF',
            contrastText: '#0F172A',
        },
        cancel: {
            light: '#f1f5f9',
            main: '#cbd5e1',
            dark: '#64748b',
            contrastText: '#000',
        },
        cancelDark: {
            light: '#94a3b8',
            main: '#475569',
            dark: '#1e293b',
            contrastText: '#000',
        },
        grey2: {
            light: '#f8fafc',
            main: '#94a3b8',
            dark: '#475569',
            contrastText: '#FFF'
        },
        text: {
            primary: '#0F172A', // Alineado con tu nuevo primary
            secondary: '#475569',
            primaryTitle: '#0F172A',
            primaryText: '#475569',
            link: '#0284c7'
        },
        background: {
            default: '#F8FAFC', // Un gris azulado muy suave que complementa al negro
            main: '#FFF',
            paper: '#FFF',
            paperDark: '#0F172A',
            contrastBg: '#FCD535',
            appBar: '#FFF'
        },
        // Mantenemos tus colores personalizados intactos
        tastyRed: {
            light: '#FF0B00',
            main: '#BC0901',
            dark: '#850600',
            contrastText: '#FFF',
        },
        tastyMustard: {
            light: '#ffbb33',
            main: '#ffab00',
            dark: '#cc8900',
            contrastText: '#FFF'
        },
        usm: {
            light: '#1d45ab',
            main: '#192f67',
            dark: '#0c1836',
            contrastText: '#FFF',
            contrastTitle: '#ff9d2b'
        }
    },
    // Mantenemos tus estilos exactamente como los tenías
    components: {
        MuiPaper: {
            styleOverrides: {
                root: { borderRadius: 10, padding: 20 },
            }
        },
        MuiInputBase: {
            styleOverrides: { root: { "&:hover": {} } },
        },
        MuiInputLabel: {
            styleOverrides: { root: { "&:focused": { color: "#0F172A" } } },
        },
        MuiTypography: {
            styleOverrides: { root: {}, body1: {}, subtitle1: { color: '#454545' } }
        },
        MuiButton: {
            styleOverrides: { root: { textTransform: 'none' } }
        },
        MuiTableCell: {
            styleOverrides: {
                root: { whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFF',
                    borderRadius: 10,
                    "&:before": { display: 'none' },
                    '&.Mui-expanded': { borderRadius: '10px' },
                    '& .MuiAccordionSummary-root.Mui-expanded': { borderBottomLeftRadius: 10, borderBottomRightRadius: 10 },
                    '& .MuiAccordionDetails-root': { borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' },
                }
            }
        },
    }
}

export default lightTheme;